import { render, staticRenderFns } from "./AboutAffiantFS.vue?vue&type=template&id=66ee3b3e"
import script from "./AboutAffiantFS.vue?vue&type=script&lang=ts"
export * from "./AboutAffiantFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports